var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.EmbeddableProduct = new Class({
    Extends: OCS.WxBriefing.Classes.EmbeddableUrl,
    class_name: 'EmbeddableProduct',
    add_content: function () {
        var product_content = OCS.WxBriefing.Live.UI.replace_url_template_text(this.get_product_content());
        this.get_data(product_content);
    },
    get_data: function (product_content) {
        jQuery.get(jQuery.trim(product_content), function (data) {
            if (data) { // valid site give in URL (s1/s2/s3/s4)
                this.parseXML(data);
                if (this.viewer_options.load && this.viewer_options.init) {
                    //var container = this.options.container.replace(this.options.panel_container_prefix, this.options.map_container_prefix); // Rename so that we focus on the map element
                    OCS.DynamicScriptLoader.load({
                        load: this.viewer_options.load,
                        onComplete: function () {
                            var container = this.options.container_selector; // Rename so that we focus on the map element
                            // Set the html of the container with the new data that came in
                            jQuery('#' + container).append(data);
//                            $('#' + container).find('.panel_options_container').first().remove();
//                            $('#' + container).find('.panel_options_arrow').first().remove();
                            if (this.viewer_options.init && OCS.Product) {
                                var product_options = {};
                                if (this.viewer_options.product_options) {
                                    product_options = this.viewer_options.product_options;
                                }
                                
                                this.set_viewer(new OCS.Product[this.viewer_options.init](jQuery('#' + container), product_options));
                                this.viewer.resize();
                            }
                        }.bind(this)
                    });
                } else {
                    /// We have nothing to load, so start it all up
                    this.options.$container.append(data);
                    this.options.$container.find('.panel_options_container').first().remove();
                    this.options.$container.find('.panel_options_arrow').first().remove();
                }

                this.options.$container.css('height', '');
                this.options.$container.removeClass('empty');
            } else { // invalid site give in URL (s1/s2/s3/s4), get default from product_content and update URL to reflect, then go get data with new site id.
                var product_content = this.get_product_content();
                this.get_data(product_content);

                var index = product_content.lastIndexOf("/");
                var newSite = product_content.substr(index + 1);
                var new_state = this.get_panel_obj().get_panel_url_state();
                new_state.s = newSite.toUpperCase();
                this.update_url_state({state: new_state}, 0);
            }
        }.bind(this));
    },
    parseXML: function (xml) {
        this.xml = jQuery('<div>' + xml + '</div>');
        // Do a little cleanup and remove any script tags
        this.xml.find('script').remove();

        // Look for any embed options and store them.
        this.viewer_options = JSON.parse(this.xml.find('div.embed_options').attr('rel'));
    },
    resize: function () {
        this.parent();
        if (this.viewer) {
            this.viewer.resize();
        }
    },
    update_product: function () {
        if (this.viewer) {
            
        }
    },
    set_product_meta_info: function (product_meta_info) {
        if (this.viewer) {
            //Call the viewers get update product options
            this.viewer.update_product_options(product_meta_info);
        }
        this.parent(product_meta_info);
    },
    destroy: function () {
        if (this.viewer) {
            this.viewer.destroy();
        }
        this.parent();
    },
    update_viewer_container: function (container) {
        // Rename so that we focus on the map element
        this.parent(this.options.container_selector);
    }
});